export const GET_ORG_REPORTS = 'GET_ORG_REPORTS'
export const GET_ORG_REPORTS_SUCCESS = 'GET_ORG_REPORTS_SUCCESS'
export const GET_ORG_REPORTS_ERROR = 'GET_ORG_REPORTS_ERROR'

export const ORG_REPORTS_APPEND_NEXT = 'ORG_REPORTS_APPEND_NEXT'
export const ORG_REPORTS_APPEND_NEXT_SUCCESS
  = 'ORG_REPORTS_APPEND_NEXT_SUCCESS'
export const ORG_REPORTS_APPEND_NEXT_ERROR = 'ORG_REPORTS_APPEND_NEXT_ERROR'
